<view-file
  *ngIf="documentSearchParams.identifierId"
  [searchParams]="documentSearchParams"
  [title]="'Documents'"
  [tabKey]="'documents-tab'"
>
</view-file>
